import client from './shopifyStorefrontClient'
import { GET_CUSTOM_AIR_FRESHENER } from './shopifyQueries'
import { CREATE_CART } from './shopifyMutations'

export async function fetchCustomAirFreshenerProduct() {
  const { data } = await client.query({
    query: GET_CUSTOM_AIR_FRESHENER,
    fetchPolicy: 'no-cache',
  })

  const product = data.products.edges[0]?.node
  if (!product) throw new Error('Product not found.')

  return product
}

export async function createCartWithLines(lines: any[]) {
  const { data, errors } = await client.mutate({
    mutation: CREATE_CART,
    variables: { input: { lines } },
  })

  const cart = data?.cartCreate?.cart
  const userErrors = data?.cartCreate?.userErrors

  if (errors || (userErrors && userErrors.length)) {
    throw new Error(userErrors?.[0]?.message || 'Cart creation failed')
  }

  return cart
}
